import React, { useState, useEffect } from "react";
import { IoIosInformationCircleOutline } from "react-icons/io";

function DDown({ question, onUpdateAnswer, invalidKeys }) {
    const [answer, setAnswer] = useState("");
    const isInvalid = invalidKeys.includes(question.key);
    const [selectedStatus, setSelectedStatus] = useState("");
    const womacOptions = [
        {value:"Selecciona una opción", id:0},
        {value:"0 - Ninguno", id:1},
        {value:"1 - Poco", id:2},
        {value:"2 - Bastante", id:3},
        {value:"3 - Mucho", id:4},
        {value:"4 - Muchisimo", id:5},
    ];
    const evaOptions = [
        {value:"Selecciona una opción", id:0},
        {value:"0 - Ningún dolor", id:1},
        {value:"1", id:2},
        {value:"2", id:3},
        {value:"3", id:4},
        {value:"4", id:5},
        {value:"5", id:6},
        {value:"6", id:7},
        {value:"7", id:8},
        {value:"8", id:9},
        {value:"9", id:10},
        {value:"10 - Máximo dolor", id:11},
    ];

    const options = question.type && question.type === "eva" ? evaOptions : womacOptions

    function updateAnswerHandler(enteredValue, index) {
    setSelectedStatus(enteredValue);
    setAnswer(enteredValue);
    const answer = {
      key: question.key,
      answer: enteredValue,
      question: question.description,
      type: question.answersType,
      optional: question.optional,
    };
    onUpdateAnswer(answer);
  }

    return (
        <div className={isInvalid ? "error" : "mainClosed"}>
            <p className="question">{question.description}</p>
            <select
                onChange={(e) => updateAnswerHandler(e.target.value)}
                name="selectedStatus"
                value={selectedStatus}
                style={{
                    width: "60%",
                    flexDirection: "row",
                    paddingRight:"12px",
                    paddingLeft:"12px",
                    justifyContent:"center",
                    alignItems:"center",
                    paddingTop:"8px",
                    paddingBottom:"8px",
                    backgroundColor: "#F27059",
                    border:"3px solid #D3D0D0",
                    borderRadius: "6px",
                    color:"white"
                }}
              >
                {options.map((status) => (
                  <option key={status.id} value={status.value}>
                    {status.value}
                  </option>
                ))}
              </select>
        </div>
    );
}

export default DDown;
